const scrollTop = () => window.scrollTo(0, 0)

export default scrollTop
